const MapMixToFlats = (unitMix, dataset) => unitMix.map((m) => dataset.apartments.all.filter((a) => a.data.category === m.label));
export { MapMixToFlats };

//# sourceMappingURL=index240.js.map